module.exports = __webpack_public_path__ + "img/hskz2.8ed0f712.png";